<template>
<v-layout align-center justify-center :style="{height: height, background: cardColor}" class="elevation-4 ma-0">
  <v-card :style="{background: cardColor}" flat>
    <v-card-text class="pa-0">
      <v-container fluid class="pa-0">
        <v-layout align-center justify-center fill-height row class="ma-0">
          <v-flex xs12 class="text-sm-center py-3 white--text">
            <div class="metric" :style="{fontSize: fontSize}">{{ metric }}</div>
            <span class="caption" v-if="subtitle">{{ subtitle }}</span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</v-layout>
</template>

<script>
export default {
  components: {

  },
  props: {
    metric: {
      type: Number,
      default: 0
    },
    subtitle: String,
    icon: String,
    cardColor: {
      type: String,
      default: 'white'
    },
    height: { type: String, default: '110px' },
    chartColor: Array,
    data: Array,
    fontSize: {
      type: String,
      default: '2.5em'
    }
  },
  
  data () {
    return {
      isDark: false
    }
  },
  computed: {
    computeCardDark () {
      var self = this
      if(!self.isDark){
        return false
      } else {
        return true
      }
    },
  },
  created () {
    var self = this
    self.$root.$on('is-dark', (isDark) => {
      if(isDark !== 'undefined' && isDark !== null){
        self.isDark = isDark
        self.$nextTick(() => {
          self.$root.$emit('refresh-chart')
        })
      } else {
        console.log(isDark)
      }
    })
  },
  beforeDestroy () {
    var self = this
    self.$root.$off('is-dark')
  },
  mounted () {
    var self = this
    self.isDark = self.$vuetify.dark
  }
}
</script>
<style scoped>
 .light-actions {
   color: #FFFFFF!important;
 }
.v-card-actions {
  font-family: 'Roboto Mono, Roboto, sans-serif';
  color: #FFFFFF!important;
}
.metric {
    font-size: 2.5em;
    font-weight: 300!important;
}
.chart-caption {
  font-size:16px!important;
  font-weight: 300!important;
  text-transform: uppercase;
}
.headline, .caption {
    font-weight:300!important;
}
</style>